module.exports = __webpack_public_path__ + "static/media/AA.c81c59ed.jpg";